import { createStyles, makeStyles } from "@material-ui/core";
import { tesaDarkRedError, tesaGreenPositive } from "../../../styles/colors";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "block",
      margin: "0 auto",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "space-between",
    },
    successMessage: { color: tesaGreenPositive },
    errorMessage: { color: tesaDarkRedError },
    moreVertIcon: {
      height: "14px",
    },
  }),
);

export default useStyles;
